const sliceThreshold = 9; // must be an odd number to work correctly
const offsetMax = 2;

const getPages = (currentPage, maxPages) => {
    let pages = Array.from(new Array(maxPages))
        .map((el, i) => i + 1);

    if (maxPages > sliceThreshold) {
        let offset = Math.floor((sliceThreshold - 1) / 2);
        if (offset > offsetMax) {
            offset = offsetMax;
        }

        const preOffset = Math.max(currentPage - offset - 1, 0);

        pages = pages.slice(preOffset, currentPage + offset);
    }

    return pages;
};

export { getPages }